<<template>  
  <prop-panel @close="close" width="900px">
    <p slot="header">{{rs["group"]}}</p>
    
    <div class="row" style="margin-left:0">
      <div class="input-group" style="margin-left:0">
        <div class="form-control col-md-11" style=" height: auto;min-height:26px;">
         <label v-for='item in shiftList' style="margin-left: 30px;">
          <input type="checkbox" :value="item.shiftNo" v-model="items"/>{{item.shiftName}}({{item.shiftNo}})</label>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button @click.stop="close" type="button" class="btn btn-default" data-dismiss="modal">{{rs["btn_close"]}}</button>
    </div>
  </prop-panel>
</template>

<<script>
export default {
  created(){
      this.items=[]
      this.xdata.forEach(d=>{
        this.items.push(d.shiftNo)
      })
  },
  props:["shiftList", "xdata", "rs"],
  data(){
    return{
      items: null
    }
  },
  methods:{
    close: function() {
      const dt=[]
      let tmp
      let obj
      this.items.forEach(d=>{
        tmp = this.shiftList.find(x=>{return x.shiftNo==d})
        if (tmp){
          obj = {shiftNo:tmp.shiftNo, shiftName:tmp.shiftName}
          dt.push(obj)
        }
      })
      this.$emit("close", dt);
    }
  }
}
</script>
